import Contracts from '../config/contract.json';
import PresaleABI from '../config/abi/Presale.json';
import { useContractRead } from 'wagmi'


const SaleContract = () =>{
    return Contracts.presale;
}

export const SaleStartTime = () => {

    return String(useContractRead({
        address: SaleContract(),
        abi: PresaleABI,
        functionName: 'saleStartTime'
      }).data);
}

export const SaleEndTime = () => {

    return String(useContractRead({
        address: SaleContract(),
        abi: PresaleABI,
        functionName: 'saleEndTime'
      }).data);
}

export const TokenRatePerEth = () => {

    return String(useContractRead({
        address: SaleContract(),
        abi: PresaleABI,
        functionName: 'tokenRatePerEth'
      }).data);
}

export const TotalSolded = () => {

    return String(useContractRead({
        address: SaleContract(),
        abi: PresaleABI,
        functionName: 'totalSolded'
      }).data);
}

export const Hardcap = () => {

    return String(useContractRead({
        address: SaleContract(),
        abi: PresaleABI,
        functionName: 'hardcap'
      }).data);
}

export const MinimumBuy = () => {

    return String(useContractRead({
        address: SaleContract(),
        abi: PresaleABI,
        functionName: 'minEthLimit'
      }).data);
}

export const MaximumBuy = () => {

    return String(useContractRead({
        address: SaleContract(),
        abi: PresaleABI,
        functionName: 'maxEthLimit'
      }).data);
}

export const IsClaim = () => {

  return String(useContractRead({
      address: SaleContract(),
      abi: PresaleABI,
      functionName: 'isClaim'
    }).data);
}

export const UserBalance = (account) => {

  return String(useContractRead({
      address: SaleContract(),
      abi: PresaleABI,
      functionName: '_userBalance',
      args:[account]
    }).data);
}

export const IsRef = () => {

  return String(useContractRead({
      address: SaleContract(),
      abi: PresaleABI,
      functionName: 'isRef'
    }).data);
}

export const RefPercent = () => {

  return String(useContractRead({
      address: SaleContract(),
      abi: PresaleABI,
      functionName: 'refPercent'
    }).data);
}

export const EarnedRefBalance = (address) => {

  return String(useContractRead({
      address: SaleContract(),
      abi: PresaleABI,
      functionName: '_earnedRefBalance',
      args:[address]
    }).data);
}